/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * `completed` is set by `POST .../complete`. **`abandoned` is set when the visit ends** with
 * the attempt still `in_progress` — by learner `end`, facilitator `close`, or the idle sweep,
 * in the same transaction. Nothing else writes it, and no attempt stays `in_progress` past
 * the end of its visit.
 * 
 * @export
 */
export const AttemptStatus = {
    InProgress: 'in_progress',
    Completed: 'completed',
    Abandoned: 'abandoned',
} as const;
export type AttemptStatus = typeof AttemptStatus[keyof typeof AttemptStatus];


export function instanceOfAttemptStatus(value: any): boolean {
    for (const key in AttemptStatus) {
        if (Object.prototype.hasOwnProperty.call(AttemptStatus, key)) {
            if (AttemptStatus[key as keyof typeof AttemptStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AttemptStatusFromJSON(json: any): AttemptStatus {
    return AttemptStatusFromJSONTyped(json, false);
}

export function AttemptStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttemptStatus {
    return json as AttemptStatus;
}

export function AttemptStatusToJSON(value?: AttemptStatus | null): any {
    return value as any;
}

export function AttemptStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AttemptStatus {
    return value as AttemptStatus;
}

